import { isArray } from 'lodash';
import Swiper, { Navigation, Pagination } from 'swiper';
import Viewer from 'viewerjs';

Swiper.use([Navigation, Pagination]);

// Run the functions on document ready
document.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('.swiper-image-carousel', {
        init: false,
        spaceBetween: 24,
        slidesPerView: 1.5,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        breakpoints: {
            768: {
                spaceBetween: 24,
                slidesPerView: 2.5,
                slidesOffsetBefore: 48,
                slidesOffsetAfter: 48
            },
            1024: {
                slidesPerView: 2.5,
                slidesOffsetBefore: 48,
                slidesOffsetAfter: 48
            },
            1280: {
                slidesOffsetBefore: 64,
                slidesOffsetAfter: 64
            },
            1440: {
                slidesPerView: 3.5,
                slidesOffsetBefore: 80,
                slidesOffsetAfter: 80,
                spaceBetween: 32
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
            clickable: true
        }
    });

    // If there are modals inside the swiper container
    // Then move them out as transform has a quirky effect
    // on postion: fixed items
    // const swiperImageCarousels = document.querySelectorAll<HTMLElement>('.swiper-image-carousel');
    // swiperImageCarousels.forEach(swiperCarousel => {
    //     const modals = swiperCarousel.querySelectorAll('.modal');
    //     modals.forEach(modal => document.querySelector('body')?.appendChild(modal));
    // });

    if (isArray(swiper)) {
        swiper.forEach(s => s.init());
    } else {
        swiper.init();
    }

    const imageCarousels = document.querySelectorAll<HTMLElement>('.image-carousel');
    imageCarousels.forEach(imageCarousel => {
        const images = imageCarousel.querySelector<HTMLElement>('.swiper-wrapper');
        if (images) {
            const viewer = new Viewer(images, {
                navbar: false,
                title: false,
                movable: false,
                toolbar: {
                    zoomOut: 1,
                    zoomIn: 1,
                    reset: 1,
                    prev: 1,
                    next: 1
                }
            });
            viewer.hide();
        }
    });

    const imagePopups = document.querySelectorAll<HTMLElement>('.image-popup-wrapper');
    imagePopups.forEach(imagePopups => {
        const images = imagePopups.querySelector<HTMLElement>('.image-popup');
        if (images) {
            const viewer = new Viewer(images, {
                navbar: false,
                title: false,
                movable: false,
                toolbar: {
                    zoomOut: 1,
                    zoomIn: 1,
                    reset: 1,
                    prev: 0,
                    next: 0
                }
            });
            viewer.hide();
        }
    });
});
